<template>
    <dash
        icon="fa fa-book"
        titulo="PROJETOS SGTEC"
        subTitulo="GESTOR"
        @click.native="$router.push({ name: 'Sgtec_Gestores_Projetos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
